import t from '../helpers/translate';
import ExternalLink from './ExternalLink';
import Svg from './Svg';
import takeMeFishingLogoImage from '../images/take-me-fishing-logo.png';
import vamosAPescarLogoImage from '../images/vamos-a-pescar-logo.png';
import '../styles/footer.css';
import getBaseUrl from '../helpers/getBaseUrl';
import getLocale from '../helpers/getLocale';

const EmbeddedFooter = () => (
  <div className="footer">
    <div className="footer-attributions">
      <div className="footer-attribution">
        <p>{t('Map provided by')}</p>
        <div className="responsive-image">
          <ExternalLink href={getBaseUrl()}>
            <img
              className="footer-logo footer-logo-tmf"
              src={getLocale() === 'es' ? vamosAPescarLogoImage : takeMeFishingLogoImage}
              alt={t('Take Me Fishing')}
            />
          </ExternalLink>
        </div>
      </div>
      <div className="footer-attribution">
        <p>{t('With catches data from')}</p>
        <ExternalLink ariaLabel="Fishbrain" href="https://www.fishbrain.com">
          <Svg viewBox="0 0 138 26" className="footer-logo footer-logo-fib" icon="logo" />
        </ExternalLink>
      </div>
      <div className="footer-embed">
        <a href="https://www.takemefishing.org/placesmap/">{t('Add this map to your website')}</a>
      </div>
    </div>
  </div>
);

export default EmbeddedFooter;
